import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { pages } from "../constants/pages"; // Ensure this includes all your pages
import useDeviceType from "../hooks/useDeviceType"; // Import the hook for device detection
import Hamburger from "../common_components/Hamburger"; // Import HamburgerMenu
import FooterMobile from "../common_components/FooterMobile";
import "../styles/Layout.scss";

const Layout = () => {
  const location = useLocation();
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const isMobile = useDeviceType(); // Detect if the device is mobile

  // Filter pages to exclude the current one
  const filteredPages = pages?.filter((page) => page.path !== location.pathname) || [];

  const handleLightboxState = (state) => {
    setIsLightboxOpen(state);
  };

  return (
    <div className={`layout ${isLightboxOpen ? "lightbox-active" : ""}`}>
      {/* Frame Lines */}
      <div className={`frame top ${isLightboxOpen ? "hidden" : ""}`}></div>
      <div className={`frame bottom ${isLightboxOpen ? "hidden" : ""}`}></div>
      <div className={`frame left ${isLightboxOpen ? "hidden" : ""}`}></div>
      <div className={`frame right ${isLightboxOpen ? "hidden" : ""}`}></div>

      {/* Navbar or HamburgerMenu */}
      {isMobile ? (
        <Hamburger routes={filteredPages} />
      ) : (
        <nav className={`navbar ${isLightboxOpen ? "hidden" : ""}`}>
          {filteredPages.map((page) => (
            <a key={page.path} href={page.path}>
              {page.name}
            </a>
          ))}
        </nav>
      )}

      {/* Page Content */}
      <div className="content">
        <Outlet context={{ handleLightboxState }} />
      </div>
       {/* Mobile Footer */}
       {isMobile && <FooterMobile />}
    </div>
  );
};

export default Layout;
